import { UseMutationResult } from "@tanstack/react-query";
import { ErrorResponsesCreateOrUpdate, Record } from "../../../types/records.types";
import { getStore } from "../../../store/store";

export const batchAssociateOrdersToTransaction = async (
    orderPaymentIds: Array<string | number>,
    bankTransactionId: string | number,
    updateRecord: UseMutationResult<any, ErrorResponsesCreateOrUpdate, Record, any>
) => {
    const { notifications } = getStore();

    try {
        const updatePromises = orderPaymentIds.map((paymentId) =>
            updateRecord.mutateAsync({
                id: paymentId,
                entity: "orders_payments",
                data: {
                    connected_bank_transaction_id: bankTransactionId,
                },
            })
        );

        await Promise.all(updatePromises);

        notifications.setNotification({
            isOpen: true,
            message: `${orderPaymentIds.length} compra(s) associada(s) ao movimento bancário com sucesso`,
            severity: "success",
        });
    } catch (error) {
        notifications.setNotification({
            isOpen: true,
            message: "Não foi possível associar as compras ao movimento bancário",
            severity: "error",
        });
    }
};
